import { render, staticRenderFns } from "./formDiagnostics.vue?vue&type=template&id=9de5f232"
import script from "./formDiagnostics.vue?vue&type=script&lang=js"
export * from "./formDiagnostics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports